import cx from 'classnames';
import { useEffect, useState } from 'react';
import FeatureItem from './FeatureItem';
import styles from './PlanDetails.module.scss';
import { icons } from '../../assets';
const { ArrowDownIcon } = icons;

function PlanDetails({
  title = 'Plan Details',
  titleSectionStyle = {},
  pointsClassName = '',
  style,
  features = [],
  makeTitleBold = false,
  keepDetailsOpen = true,
  separatorTitle = '',
  features2 = [],
  children,
  handleExpand = () => {},
  hideAccordion = null,
  designV2 = false,
}) {
  const [open, toggle] = useState(keepDetailsOpen);

  useEffect(() => {
    open !== keepDetailsOpen && toggle(keepDetailsOpen);
  }, [keepDetailsOpen]);

  return (
    <div className={styles.container} style={style}>
      {!designV2 ? (
        <div
          className={styles.toggler}
          style={titleSectionStyle}
          onClick={() => {
            if (!hideAccordion) {
              handleExpand();
              toggle(!open);
            }
          }}>
          <div className={cx(styles.toggleTitle, makeTitleBold && styles.bold)}>{title}</div>
          {!hideAccordion && <ArrowDownIcon style={open ? { transform: 'rotate(-180deg)' } : {}} />}
        </div>
      ) : null}
      <div
        className={cx(styles.planKeyPoints, pointsClassName)}
        style={!open ? { display: 'none' } : {}}>
        {features.length !== 0 && (
          <ul className={styles.features} style={!open ? { display: 'none' } : {}}>
            {features.map((a) => (
              <FeatureItem key={a.id} title={a.description} theme={designV2 ? 'dark' : ''} />
            ))}
            {features2.length > 0 && (
              <>
                <li
                  style={{
                    marginBottom: '16px',
                    padding: '16px 0',
                    borderBottom: '1px solid #eee',
                  }}>
                  {separatorTitle}
                </li>
                {features2.map((a) => (
                  <FeatureItem key={a.id} title={a.description} />
                ))}
              </>
            )}
          </ul>
        )}
        {children}
      </div>
    </div>
  );
}

export default PlanDetails;
